
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import Hero from './components/Hero';
import ProductShowcase from './components/ProductShowcase';
import Benefits from './components/Benefits';
import Process from './components/Process';
import UseCases from './components/UseCases';
import FAQ from './components/FAQ';
import CallToActionSection from './components/CallToActionSection';
import { getLocalizedContent } from './utils/localization';

const ProductVideosPage = () => {
  const { currentLanguage } = useLanguage();
  const { lang } = useParams<{ lang: string }>();
  const t = translations[currentLanguage];
  
  useEffect(() => {
    document.title = `${t.productVideos} | Future Level`;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', t.productVideosDesc);
    }

    // Add schema.org structured data for better SEO
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Service',
      'name': `${t.productVideos} - Future Level`,
      'description': t.productVideosDesc,
      'provider': {
        '@type': 'Organization',
        'name': 'Future Level',
        'url': window.location.origin
      },
      'serviceType': 'AI Video Production',
      'areaServed': {
        '@type': 'Country',
        'name': 'Switzerland'
      },
      'offers': {
        '@type': 'Offer',
        'description': t.productVideosDesc
      }
    });
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [currentLanguage, t]);

  const content = getLocalizedContent(currentLanguage);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Hero t={t} content={content} />
        <ProductShowcase content={content} />
        <Benefits content={content} />
        <Process content={content} />
        <UseCases content={content} />
        <FAQ content={content} />
        <CallToActionSection t={t} content={content} currentLanguage={currentLanguage} />
      </main>
      <Footer />
    </div>
  );
};

export default ProductVideosPage;
